import * as React from "react";
import { useState, useEffect } from "react";
import i18n from "i18n";
import { Typography, Switch, Grid, withStyles } from "@material-ui/core";
import NumberField from "common/components/fields/NumberField";
import { gtag } from "ga-gtag";
const styles = () => ({
  propertiesGroup: {
    background: "#363637",
    padding: "15px",
    paddingBottom: "0px",
  },
  inputInfo: {
    width: "100%",
    marginBottom: "25px",
  },
  infoSubtitle: {
    fontSize: "11px",
    fontWeight: 400,
    color: "rgba(255,255,255,0.67)",
    textTransform: "uppercase" as any,
    fontFamily: "Roboto",
  },
  wbsSubtitle: {
    padding: 0,
    fontFamily: "Roboto",
    fontSize: "10px",
    fontWeight: 400,
    color: "rgba(255,255,255,0.67)",
  },
  switchColor: {
    color: "#1b1b1b",
  },
  colorSwitchBase: {
    color: "#dedede",
    "&$colorChecked": {
      color: "#ABC200",
      "& + $colorBar": {
        backgroundColor: "#ABC200",
      },
    },
  },
  colorBar: {},
  colorChecked: {
    color: "#ABC200",
  },
});

const BDIProperties = ({ classes, containerClass, data, onChange }) => {
  const i18nLabel = i18n.project.rightSideMenu.bdi;
  const [checked, setChecked] = useState(data.show);

  useEffect(() => {
    if (data.show !== checked) {
      setChecked(data.show);
    }
  }, [data.show]);

  const handleChangeSwitch = (ev, checked) => {
    if (checked) {
      gtag("event", "ativacao_bdi", {
        ativacao_bdi: 0,
      });
    } else {
      gtag("event", "desativacao_bdi", {
        desativacao_bdi: 0,
      });
    }
    onChange(ev, checked);
    setChecked(checked);
  };

  return (
    <div className={containerClass}>
      <Typography className={classes.infoSubtitle}>
        {i18nLabel.title}
      </Typography>
      <NumberField
        id="inputBdi"
        name="percentual"
        className={classes.inputInfo}
        label={i18nLabel.percentual}
        value={data.percentual}
        onInputBlur={(ev, value) => onChange(ev, value || 0)}
        margin="normal"
      />
      <div>
        <Typography className={classes.wbsSubtitle} component="span">
          {i18nLabel.showInEap}
        </Typography>
        <Grid style={{ marginLeft: "-0.9rem" }}>
          <Switch
            name="show"
            color={"primary"}
            checked={checked}
            onChange={handleChangeSwitch}
            classes={{
              colorPrimary: classes.switchColor,
              switchBase: classes.colorSwitchBase,
              bar: classes.colorBar,
              checked: classes.colorChecked,
            }}
          />
        </Grid>
      </div>
    </div>
  );
};

export default withStyles(styles)(BDIProperties);



// WEBPACK FOOTER //
// ./src/modules/projectRightMenu/components/layouts/WBSProperties/BdiProperties.tsx